import Model from './Model';

export default class Download extends Model {
  resource() {
    return 'downloads';
  }
}
